///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents = abcsetup.atp_documents || {};
abcsetup.atp_documents.show = abcsetup.atp_documents.show || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents.show = {
    /**
     *
     */
    init: function () {
        abcsetup.setTitle('Authorized Trading Partner');
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        var close_btn = $("a:contains('Close')");
        close_btn.attr("href", "#");
        close_btn.on("click", function() {
            history.back();
        });
    },

}